import React from 'react';
import cn from 'classnames';

import { UIButton } from 'app/components/ui';

import styles from './add-to-basket-button-ui.scss';
import iconAdded from './added.img.svg';


export function AddToBasketButtonUI(props) {
    const {
        handleAddToBasket,
        isDishInBasket,
        buttonsDisabled,
        hasDiscount,
        price,
        originalPrice,
    } = props;

    const buttonDiscountClasses = cn({
        [styles['dish-layout-secondary__button-discount']]: true,
        [styles['dish-layout-secondary__button-discount--hidden']]: isDishInBasket,
    });

    const buttonIconClasses = cn({
        [styles['dish-layout-secondary__button-icon']]: true,
        [styles['dish-layout-secondary__button-icon--shown']]: isDishInBasket,
    });

    return (
        <UIButton
            sizeType="medium"
            onClick={handleAddToBasket}
            disabled={isDishInBasket || buttonsDisabled}
            aria-label="Добавить в корзину"
        >
            <span className="price">
                <span className="num">{price}</span>
                <span className="rub">₽</span>
            </span>
            {hasDiscount && (
                <span className={buttonDiscountClasses}>
                    <span className="original-price">
                        <span className="num">{originalPrice}</span>
                        <span className="rub">₽</span>
                    </span>
                </span>
            )}
            <span className={buttonIconClasses}>
                <img src={iconAdded} alt="галочка, ты не поверишь" />
            </span>
        </UIButton>
    );
}
